import { IconContainer } from "@src/components/helper.styled";

const AiConfidenceIcon = () => {
	return (
		<IconContainer>
			<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M9 1.5L15 4V9C15 12.5 12.5 15.3 9 16.5C5.5 15.3 3 12.5 3 9V4L9 1.5Z"
					stroke="white"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M9 6V9.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
				<circle cx="9" cy="12.25" r="0.9" fill="white" />
			</svg>
		</IconContainer>
	);
};

export default AiConfidenceIcon;
